import { render, staticRenderFns } from "./index-income.vue?vue&type=template&id=47bcbdfc&scoped=true&"
import script from "./index-income.vue?vue&type=script&lang=js&"
export * from "./index-income.vue?vue&type=script&lang=js&"
import style0 from "./index-income.vue?vue&type=style&index=0&id=47bcbdfc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bcbdfc",
  null
  
)

export default component.exports